import { CalendarPlus, Plus } from "lucide-react";

// Empty-state banner shown above the (still-rendered) calendar grid when the
// user has no linked Google calendars. The page no longer hard-gates on
// linkedCalendars.length > 0 — users can author free-time marks regardless.
export function EmptyAvailabilityState({ onLinkClick, onAddMarkClick }) {
  return (
    <div className="rounded-2xl border border-dashed border-slate-300 bg-white/40 p-6 text-center dark:border-slate-700 dark:bg-slate-900/40">
      <CalendarPlus
        className="mx-auto h-8 w-8 text-slate-400"
        aria-hidden="true"
      />
      <h3 className="mt-3 text-base font-semibold">
        No linked calendars yet
      </h3>
      <p className="mx-auto mt-1 max-w-md text-sm text-slate-500 dark:text-slate-400">
        You can still author free-time blocks by clicking on a day or dragging
        in week view. Or link a Google calendar to see your existing events.
      </p>
      <div className="mt-4 flex flex-wrap items-center justify-center gap-2">
        {onAddMarkClick && (
          <button
            type="button"
            onClick={onAddMarkClick}
            className="rounded-xl bg-brand-primary px-3 py-2 text-sm font-medium text-white shadow-sm hover:bg-brand-primary/90"
          >
            <Plus className="-ml-1 mr-1 inline-block h-4 w-4" /> Add availability mark
          </button>
        )}
        <button
          type="button"
          onClick={onLinkClick}
          className="rounded-xl border border-slate-300 px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50 dark:border-slate-700 dark:text-slate-200 dark:hover:bg-slate-800"
        >
          Link a Google calendar
        </button>
      </div>
    </div>
  );
}

export default EmptyAvailabilityState;
